import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PollService } from 'src/app/core/http/poll/poll.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';

@Component({
  selector: 'app-poll-statistics',
  templateUrl: './poll-statistics.component.html',
  styleUrls: ['./poll-statistics.component.css']
})
export class PollStatisticsComponent implements OnInit {

  poll_id = null;
  poll;
  poll_statistics;
  
  constructor(private pollService: PollService, private route: ActivatedRoute) {
    this.poll_id = this.route.snapshot.paramMap.get("id");
  }

  ngOnInit(): void {
    this.getPollStats()
  }
  getPollStats() {
    forkJoin([this.pollService.getPollStatistics(this.poll_id), this.pollService.getCurrentPoll(this.poll_id)]).subscribe( res   => {
      this.poll = res[1];
      this.poll_statistics = Object.values(this.groupStatResults(res[0]));
    })
  }
  
  groupStatResults(xs) {
    let key = 'field'
    const answersByKey = _.groupBy(xs, key);
    return _.mapValues(answersByKey, x => {
        return {
          answers: x.map(y => {
            return _.omit(y, [key, 'title', 'wd_id']);
          }),
          title: x[0].title,
          wd_id: x[0].wd_id
        }
      })
  };
  exportAsPDF(id, name) {
    //let data = document.getElementById(id);
    var node = document.getElementById(id);

    var img;
    var filename;
    var newImage;


    domtoimage.toPng(node, { bgcolor: '#fff' })

      .then(function(dataUrl) {

        img = new Image();
        img.src = dataUrl;
        newImage = img.src;

        img.onload = function(){

        var pdfWidth = img.width;
        var pdfHeight = img.height;

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image

          var doc;

          if(pdfWidth > pdfHeight)
          {
            doc = new jspdf('l', 'px', [pdfWidth , pdfHeight]);
          }
          else
          {
            doc = new jspdf('p', 'px', [pdfWidth , pdfHeight]);
          }


          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();


          doc.addImage(newImage, 'PNG',  10, 10, width, height);
          if (name) {
            filename = name + '.pdf';
          } else {
            filename = 'Статистика' + '.pdf';
          }
          doc.save(filename);

        };


      })
      .catch(function(error) {

        // Error Handling

      });

    /*html2canvas(data).then(canvas => {  
      // Few necessary setting options  
      let canvass = canvas[1];
      var imgWidth = 208;   
      var pageHeight = 295;    
      var imgHeight = canvass.height * imgWidth / canvass.width;  
      var heightLeft = imgHeight;  
  
      const contentDataURL = canvass.toDataURL('image/png')  
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
      var position = 0;  
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
      pdf.save('MYPdf.pdf'); // Generated PDF   
    });*/
  }

}
